import { EventEmitter, TemplateRef } from "@angular/core";

export interface ISearchResponse {
    results: ISearchResponseRowContainer[];
}

export interface ISearchResponseRowContainer {
    rows: ISearchResponseRow[];
    queryResultType: string;
}

export interface ISearchResponseRow {
    type: string;
    naturalKey?: string;
    title?: string;
    metadata?: { [key: string]: any };
    id?: number;
}
export interface ISearchResultRenderer {
    input: ISearchResponseRow;
    tooltipTemplate: TemplateRef<any>;
    searchExtended?: EventEmitter<any>;
}

export type SearchResultRendererType =
    "Default" |
    "Arbetsorder" |
    "Virkeskopskontrakt" |
    "VirkeskopskontraktFPV" |
    "Kundorder" |
    "Leverantorsorder" |
    "Terminalorder" |
    "Handelssortiment" |
    "Produktinstruktion" |
    "Produkt" |
    "NoResult" |
    "NoResultShowNavet";

export class QueryResultTypes {

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Arbetsorder = "Arbetsorder";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Kundorder = "Kundorder";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Handelssortiment = "Handelssortiment";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Virkeskopskontrakt = "Virkeskopskontrakt";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static VirkeskopskontraktFPV = "VirkeskopskontraktFPV";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Produkt = "Produkt";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Terminalorder = "Terminalorder";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Leverantorsorder = "Leverantorsorder";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Produktinstruktion = "Produktinstruktion";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Modal = "Modal";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static NoResult = "NoResult";
}
